import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }

import RichTextField from '@/components/common/RichTextField.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { GoalsActions, GoalsState } from '@/stores/goals.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import CategoryField from '../categories/CategoryField.vue';

import {
  descriptionRules,
  Goal,
  GoalItem,
  titleRules,
  defaultGoal,
} from '@/models/goal.model';
import GoalItems from './GoalItems.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GoalForm',
  props: {
  data: {
    type: Object as PropType<Goal>,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { ev: GoalsState }>();

const events = useEvents();

const props = __props;

const valid = ref<boolean>(false);

const goal = ref<Goal>({ ...defaultGoal });

const currentValue = ref<Goal>({ ...defaultGoal });

const action = computed<string>(() =>
  goal.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveGoal = async (e: unknown, close = true) => {
  let success: boolean = false;
  if (valid.value) {
    if (goal.value.id === NEW_ID) {
      success = await store.dispatch(GoalsActions.AddGoal, goal.value);
    } else {
      success = await store.dispatch(GoalsActions.UpdateGoal, goal.value);
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved Goal',
      type: 'success',
    });

    if (close) {
      store.commit(Mutations.HideDrawer);
      store.dispatch(GoalsActions.GetGoals);
    }
    currentValue.value = { ...goal.value };
    store.commit(Mutations.SetDirtyState, false);
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: 'Failed to save Goal',
      type: 'error',
    });
  }
};

const updateLanguage = async () => {
  if (goal.value.id === NEW_ID) {
    Object.assign(goal, { title: '' });
  } else {
    const item = await store.dispatch(GoalsActions.GetGoal, goal.value.id);

    if (item) {
      Object.assign(goal.value, {
        ...item,
        startDate: new Date(item.startDate || new Date().toISOString()),
        endDate: new Date(item.endDate || new Date().toISOString()),
      });

      currentValue.value = { ...goal.value };
    }
  }
};

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, updateLanguage);
});

onMounted(() => {
  events.on(Event.LanguageChanged, updateLanguage);

  if (props.data) {
    Object.assign(goal.value, {
      ...props.data,
    });

    currentValue.value = { ...goal.value };
  }
});

const removeLabel = async () => {
  if (
    goal.value &&
    goal.value.id !== NEW_ID &&
    confirm('Are you absolutely sure you want to delete this "Goal"?')
  ) {
    store.dispatch(GoalsActions.DeleteGoal, goal.value.id);

    store.commit(Mutations.HideDrawer);
  }
};

const togglePublished = async (published: boolean) => {
  if (goal.value.id !== -1) {
    store.dispatch(GoalsActions.PublishGoal, {
      id: goal.value.id,
      published,
    });
  }
  goal.value.published = published;
};

function updateItems(items: GoalItem[]) {
  goal.value.items = items;
}

function getSimpleValue(i: Goal) {
  return {
    title: i.title,
    subTitle: i.subTitle,
    description: i.description,
    url: i.description,
    listTitle: i.listTitle,
    items: JSON.stringify(i.items),
  };
}

const isDirty = computed<boolean>(() => {
  const isDirty =
    JSON.stringify(getSimpleValue(goal.value)) !==
    JSON.stringify(getSimpleValue(currentValue.value));

  store.commit(Mutations.SetDirtyState, isDirty);

  return isDirty;
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveGoal, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(action.value)) + " a goal ", 1),
            (isDirty.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
              : _createCommentVNode("", true),
            _createVNode(CurrentLanguage)
          ]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: goal.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((goal.value.title) = $event)),
                    rules: _unref(titleRules),
                    label: "Title",
                    hint: "Used on goal page and in lists",
                    required: ""
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "pt-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    disabled: goal.value.id === _unref(NEW_ID),
                    onClick: _cache[1] || (_cache[1] = () => togglePublished(!goal.value.published)),
                    color: !goal.value.published ? 'success' : 'warning'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(goal.value.published ? 'Un-publish' : 'Publish'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "color"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: goal.value.subTitle,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((goal.value.subTitle) = $event)),
                    rules: _unref(titleRules),
                    label: "Subtitle",
                    hint: "Used on goal page",
                    required: ""
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: goal.value.userGoalsCount,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((goal.value.userGoalsCount) = $event)),
                    label: "Favourite count",
                    density: "compact"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(CategoryField, {
            main: "",
            modelValue: goal.value.mainCategory,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((goal.value.mainCategory) = $event)),
            label: "Main Category"
          }, null, 8, ["modelValue"]),
          _createVNode(CategoryField, {
            sub: goal.value.mainCategory,
            modelValue: goal.value.subCategory,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((goal.value.subCategory) = $event)),
            label: "Sub Category"
          }, null, 8, ["sub", "modelValue"]),
          _createVNode(RichTextField, {
            label: "Description",
            height: 200,
            rules: _unref(descriptionRules),
            modelValue: goal.value.description,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((goal.value.description) = $event)),
            media: []
          }, null, 8, ["rules", "modelValue"]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "9" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: goal.value.listTitle,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((goal.value.listTitle) = $event)),
                    rules: _unref(titleRules),
                    label: "List title",
                    hint: "Shown above the list of items",
                    required: ""
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col)
            ]),
            _: 1
          }),
          _createVNode(GoalItems, {
            items: goal.value.items,
            onUpdate: updateItems,
            goal: goal.value
          }, null, 8, ["items", "goal"]),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "button",
                    color: "warning",
                    onClick: removeLabel,
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("Delete")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (saveGoal($event, false))),
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value) + " ", 1),
                      (isDirty.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value) + " and close ", 1),
                      (isDirty.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})